import React, { useEffect } from "react";
import useStyles from "../common/Styles";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import industryMap from "../../../../assets/Water_User_Industry.json";
import { useSelector } from "react-redux";
import { Box } from "@material-ui/core";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";

var map;
var allModelLayer;
var legend;

function IndustryMap() {
  const classes = useStyles();
  const { toggle_about, industry_selected } = useSelector(
    (state) => state.water_user
  );
  const { isMobile } = useGetViewPortDimensions();

  useEffect(() => {
    if (map) {
      map.remove();
    }
    map = L.map("map", {
      center: new L.LatLngBounds(
        new L.LatLng(31, -114),
        new L.LatLng(36, -108.2)
      ).getCenter(),
      zoomControl: false,
      doubleClickZoom: true,
      scrollWheelZoom: true,
      zoom: 7,
      maxZoom: 10,
      // maxZoom: 11,
      minZoom: 6,
      maxBounds: [
        //south-west coordinates
        // [31, -114],
        [30, -115],
        //north-east coordinates
        // [36, -108.2],
        [37.5, -108.0],
      ],
      maxBoundsViscosity: 1.0,
      layers: [
        L.tileLayer(
          "https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png",
          {
            noWrap: true,
            attribution:
              '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: "abcd",
          }
        ),
      ],
    });
    // add zoom control
    L.control
      .zoom({
        position: "topright",
      })
      .addTo(map);
  }, [toggle_about]);

  const featureMap = () => {
    if (allModelLayer) {
      allModelLayer.remove();
    }
    allModelLayer = L.geoJSON(industryMap, {
      pointToLayer,
      onEachFeature,
    }).addTo(map);
  }
  useEffect(featureMap, [toggle_about, industry_selected]);

  const pointToLayer = (feature, latlng) => {
    const circle = L.circleMarker(latlng, {
      radius: 9,
      fillColor: feature.properties.type === "power" ? "#2352D0" : "#D88C31",
      color: "#FFFFFF",
      weight: 0.5,
      fillOpacity: 0.7,
    }).bindTooltip(feature.properties.company_name, {
      direction: "top",
      offset: L.point({ x: 0, y: -9 }),
    });
    // .openTooltip();
    return circle;
  };

  const onEachFeature = (feature, layer) => {
    if (feature.properties.company_name === industry_selected.name) {
      highlightFeature(layer);
    }
  };

  const highlightFeature = (layer) => {
    layer.setStyle({
      weight: 3,
      color: "#3559C8",
    });

    if (!L.Browser.ie && !L.Browser.opera && !L.Browser.edge) {
      layer.bringToFront();
    }

    map.setView([layer._latlng.lat, layer._latlng.lng], 8);
  };

  const constructDOM = () => {
    if (legend) {
      legend.remove();
    }
    legend = L.control({ position: "topleft" });
    legend.onAdd = function (map) {
      var div = L.DomUtil.create("div", "info legend");
      div.innerHTML += `<div style="padding: 18px 0px 18px 0px" class='legendTitle'>Types of Industry</div>`;
      div.innerHTML += `<div class = 'labelGroup'><i style="background:#2352D0B3"></i><span class='legendLabel'>Power</span></div><br/>`;
      div.innerHTML += `<div class = 'labelGroup'><i style="background:#D88C31B3"></i><span class='legendLabel'>Mining</span></div><br/>`;
      return div;
    };
    legend.addTo(map);
  }
  useEffect(constructDOM, [map]);

  return (
    <Box className={isMobile ? classes.mapAreaResponsive : classes.mapArea}>
      <div className={isMobile ? classes.mapResponsive : classes.map} id="map"></div>
    </Box>
  );
}

export default IndustryMap;
